module.exports = __webpack_public_path__ + "img/uk_success_4.e762453d.png";